import { SubscriptionId } from 'reactApp/modules/fastCheckout/fastCheckout.types';
import { ISubscription } from 'reactApp/modules/subscriptions/subscriptions.types';

export enum BillingBuyTemplates {
    CLOUD_B2C_MOBILE = 'CLOUD_B2C_MOBILE',
    CLOUD_B2C_REG_MOBILE = 'CLOUD_B2C_REG_MOBILE',
    CLOUD_B2C = 'CLOUD_B2C',
    CLOUD_B2C_REG = 'CLOUD_B2C_REG',
    CHECKOUT_VKPAY = 'CHECKOUT_VKPAY',
    CHECKOUT_VKPAY_NOOFFER = 'CHECKOUT_VKPAY_NOOFFER',
}

export enum BillingBuyViewTemplates {
    checkout = 'checkout',
}

export interface BuyApiParams {
    product_id: SubscriptionId;
    admitad_uid: string;
    skin?: BillingBuyTemplates;
    view?: BillingBuyViewTemplates;
    pay_method?: string;
    source?: string;
    partner?: string;
}

export interface RenewApiParams {
    sub_id: SubscriptionId;
    skin?: BillingBuyTemplates;
    view?: BillingBuyViewTemplates;
}

export enum BuyNotifications {
    renewFailure = 'SUBSCRIPTION_RENEW_FAILURE',
    cancelAutoRenewFailure = 'SUBSCRIPTIONS_CANCEL_AUTORENEW_FAILURE',
    autoRenewFailure = 'SUBSCRIPTIONS_AUTORENEW_FAILURE',
    autoRenewSuccess = 'SUBSCRIPTIONS_AUTORENEW_SUCCESS',
}

export interface IOpenCancelMailSubsDialogAction {
    subscription: ISubscription;
}

export interface IAddAutoRenewAction {
    subscription: ISubscription;
}

export interface IBuySubscription {
    id: string;
    isMobile?: boolean;
    payMethod?: string;
}

export interface IRenewSubscription {
    id: string;
}

export interface ITrialSubscription {
    id: string;
}
